import React, { Component } from "react";
import RouterContainer from "./router";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import Loader from "react-loader";

import "./globalStyle.css";
import "./components/views/runningTasksView/runningTasks.css";
import "./fontAwesome/css/font-awesome.min.css";
import appApi from "./api/appApi";
import language from "./utils/language";
import Header from "./components/layouts/Header";

class App extends Component {
	constructor(props) {
		super(props);
		// arabic/hebrew languages need right to left css.
		if (language.isLanguageRTL()) {
			language.setRTLStyle();
		}
	}
	componentDidMount() {
		// INIT CONFIG AND I18N ON APP
		appApi.getConfig();
		appApi.getI18n();
	}
	componentDidUpdate(prevProps) {
		if (
			prevProps.configLoaded !== this.props.configLoaded &&
			this.props.configLoaded === true
		) {
			let style = document.createElement("style");
			style.appendChild(document.createTextNode(""));
			document.head.appendChild(style);
			let pagination = false;
			if (
				this.props.config.css.pagination &&
				this.props.config.css.pagination.color
			) {
				style.sheet.insertRule(
					".pagination > li > a, .pagination > li > span { color:" +
						this.props.config.css.pagination.color +
						"}",
					0
				);
				style.sheet.insertRule(
					".pagination > .active > a, .pagination > .active > span, .pagination > .active > a:hover, .pagination > .active > span:hover, .pagination > .active > a:focus, .pagination > .active > span:focus .pagination>.active>a {" +
						"background-color:" +
						this.props.config.css.pagination.color +
						";border-color:" +
						this.props.config.css.pagination.color +
						"}",
					1
				);
				pagination = true;
			}
			if (
				this.props.config.css.table &&
				this.props.config.css.table.headerColor
			) {
				let index = 0;
				if (pagination)
					index = 2;
				style.sheet.insertRule(
					".react-grid-HeaderCell { background-color:" +
						this.props.config.css.table.headerColor +
						"!important }",
					index
				);
			}
			if (this.props.config.applicationName) {
				document.title = this.props.config.applicationName;
			} else {
				document.title = "Uploader";
			}
		}
	}
	render() {
		const backGroundStyle = {
			backgroundImage: `url(${this.props.config.backgroundImageURL})`,
			backgroundSize: "100% 100%",
			height: "100%",
			overflowY: "auto"
		};

		const appStyle = {
			height: "100%"
		};

		return (
			<Loader loaded={this.props.configLoaded && this.props.i18nLoaded}>
				<div className="App" style={backGroundStyle}>
					<Row bsClass="header-row">
						<Header />
					</Row>

					<Row bsClass="content-row">
						<div style={{ /*overflowY: "auto",*/ width: "100%" }}>
							<Col sm={12}>
								<div style={appStyle}>{RouterContainer}</div>
							</Col>
						</div>
					</Row>
				</div>
			</Loader>
		);
	}
}

const mapStateToProps = function(store) {
	return {
		configLoaded: store.appState.configLoaded,
		i18nLoaded: store.appState.i18nLoaded,
		config: store.appState.config
	};
};

App.propTypes = {
	configLoaded: PropTypes.bool.isRequired,
	config: PropTypes.object.isRequired
};

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js